import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'
import { getDB } from '../db/index.js';
import { isToday } from '../api/date.js';

export default defineStore('groupStore', {
	state: () => {
		return {
			groups: [],// 数组用于展示，防止更新时不刷新
			groupMap: new Map(), // map用于查询，提高查询效率
		}
	},
	actions: {
		init(groups) {
			this.groups = groups;
			this.groupMap.clear();
			groups.forEach(group => this.groupMap.set(group.id, group));
		},
		append(groups) {
			groups.forEach(group => {
				if (this.groupMap.has(group.id)) {
					const g = this.groupMap.get(group.id);
					group.members = g.members;
					Object.assign(g, group);
				} else {
					this.groups.push(group);
					this.groupMap.set(group.id, group);
				}
			});
		},
		resetRtcInfo(groups) {
			groups.forEach(group => group.rtcInfo = {})
		},
		resetMembers(groups) {
			groups.forEach(group => group.members = [])
		},
		async addGroup(group) {
			if (this.groupMap.has(group.id)) {
				this.updateGroup(group)
			} else {
				group.members = [];
				group.rtcInfo = {};
				this.groups.unshift(group);
				this.groupMap.set(group.id, group);
				await getDB().saveGroup(group);
			}
		},
		async removeGroup(id) {
			const group = this.findGroup(id);
			group.quit = true;
			await getDB().saveGroup(group);
		},
		async updateGroup(group) {
			const g = this.findGroup(group.id);
			// 成员列表保持不变
			group.members = g.members;
			// 拷贝属性
			Object.assign(g, group);
			await getDB().saveGroup(group);
		},
		async updateTopMessage(id, topMessage) {
			const group = this.findGroup(id);
			if (group) {
				group.topMessage = topMessage;
				await getDB().saveGroup(group);
			}
		},
		async setDnd(id, isDnd) {
			const group = this.findGroup(id);
			group.isDnd = isDnd;
			await getDB().saveGroup(group);
		},
		async setTop(id, isTop) {
			const group = this.findGroup(id);
			group.isTop = isTop;
			await getDB().saveGroup(group);
		},
		async setMuted(id, isMuted) {
			const group = this.findGroup(id);
			group.isMuted = isMuted;
			await getDB().saveGroup(group);
		},
		async setAllMuted(id, isAllMuted) {
			const group = this.findGroup(id);
			group.isAllMuted = isAllMuted;
			await getDB().saveGroup(group);
		},
		async setRtcInfo(id, rtcInfo) {
			const group = this.findGroup(id);
			group.rtcInfo = rtcInfo;
			await getDB().saveGroup(group);
		},
		async refreshMember(id) {
			const group = this.findGroup(id);
			// 成员最大版本号
			const version = Math.max(0, ...group.members.map(m => m.version));
			const members = await http({ url: `/group/members/${id}?version=${version}`, });
			if (!group.members.length) {
				// 全量更新
				group.members = members;
			} else {
				// 增量更新
				members.forEach(m1 => {
					const member = group.members.find(m2 => m1.userId == m2.userId);
					if (member) {
						Object.assign(member, m1);
					} else {
						group.members.push(m1)
					}
				})
				// 更新成员在线状态
				this.refreshMemberOnline(id);
			}
			await getDB().saveGroup(group);
		},
		async refreshMemberOnline(id) {
			const group = this.findGroup(id);
			const userIds = await http({ url: `/group/members/online/${id}` });
			group.members.forEach(m => m.online = userIds.some(userId => m.userId == userId));
			this.refreshMmeberSort(id);
		},
		refreshMmeberSort(id) {
			const group = this.findGroup(id);
			group.members.sort((m1, m2) => {
				// 在线的放前面
				if (m1.online && !m2.online) {
					return -1
				}
				if (!m1.online && m2.online) {
					return 1
				}
				// 群主在前面
				if (m1.userId == group.ownerId) {
					return -1;
				}
				if (m2.userId == group.ownerId) {
					return 1;
				}
				// 管理员在前面
				if (m1.isManager && !m2.isManager) {
					return -1;
				}
				if (!m1.isManager && m2.isManager) {
					return 1;
				}
				return 0;
			})
		},
		clear() {
			this.groups = [];
			this.groupMap.clear();
		},
		async pullGroups() {
			const version = Math.max(0, ...this.groups.map(g => g.version));
			const groups = await http({ url: '/group/list?version=' + version });
			this.resetMembers(groups);
			this.resetRtcInfo(groups);
			this.append(groups);
			await getDB().saveGroups(groups);
		},
		async loadGroup() {
			const lastSyncTime = await getDB().findLastSyncGroupsTime();
			if (!lastSyncTime || !isToday(new Date(lastSyncTime))) {
				// 每日首次登录进行全量同步
				const groups = await http({ url: '/group/list' });
				this.resetMembers(groups);
				this.resetRtcInfo(groups);
				this.init(groups);
				await getDB().syncAllGroups(groups);
				console.log("全量同步群聊信息")
			} else {
				// 从本地数据库加载
				const groups = await getDB().findAllGroups();
				this.resetRtcInfo(groups);
				this.init(groups);
				// 从服务器增量拉取
				await this.pullGroups();
				console.log("增量同步群聊信息")
			}
		}
	},
	getters: {
		findGroup: (state) => (id) => {
			return state.groupMap.get(id);
		},
		isGroup: (state) => (id) => {
			const group = state.groupMap.get(id);
			return group && !group.quit
		},
	}
});